import { detectAnyAdblocker } from 'vue-adblock-detector';

export async function isAdBlocker() {
  const adBlockerDetected = await detectAnyAdblocker();
  return adBlockerDetected;
}